/*
  第2c段の担当の節の CSS。担当の一覧は /Users/apple/Work/hp-renewal/v2/brief-phase2.md。
  色と余白は hp-base.ts の変数を使う。
  ヘッダーの CSS は components/GlobalHeader.tsx の中 (.hp の外にあるため)。
*/
export const FQ_CSS = `
/* よくあるご質問。左に見出し、右に罫線の一覧 */
.hp .fq{display:grid;gap:var(--gap);border-top:1px solid var(--ink);padding-top:var(--gap)}
.hp .fq-h{margin:0}
.hp .fq-item{border-bottom:1px solid var(--ink)}
.hp .fq-q{display:flex;align-items:center;justify-content:space-between;gap:12px;width:100%;padding:16px 0;background:none;border:0;color:var(--ink);text-align:left;cursor:pointer}
.hp .fq-q:focus-visible{outline:2px solid var(--focus-ring);outline-offset:2px}
.hp .fq-qt{display:flex;align-items:center;gap:12px;flex:1;min-width:0;font-weight:900;font-size:20px;line-height:1.4;letter-spacing:-.02em}
.hp .fq-i{flex:none;color:var(--ink);--icon-accent:var(--blue)}
.hp .fq-tg{--font-body-ja:var(--mono);flex:none;color:var(--blue);font-size:24px;line-height:1;font-weight:400}
.hp .fq-tg::before{content:"+"}
.hp .fq-open .fq-tg::before{content:"\u2212"}
/* PC は最初の1問だけ開く。2問目からは、押されるまで答えを畳む (スマホは今までどおり、結論は出して本文だけ畳む) */
@media (min-width:768px){.hp .fq-fold .fq-a{display:none}.hp .fq-fold .fq-tg::before{content:"+"}}
.hp .fq-a{padding:0 0 var(--in,16px)}
.hp .fq-at{max-width:720px}
.hp .fq-verdict{margin:0;font-size:15px;font-weight:700;line-height:1.85;color:var(--ink)}
.hp .fq-who{display:grid;gap:10px}
.hp .fq-who-i{display:flex;align-items:flex-start;gap:10px}
.hp .fq-who-ic{flex:none;margin-top:.3em;color:var(--ink)}
.hp .fq-pay{margin-top:.6em;white-space:normal}
.hp .fq-pay-caps{display:flex;flex-wrap:wrap;gap:4px 16px;margin:6px 0}
.hp .fq-pay-cap{display:inline-flex;align-items:center;gap:6px;font-size:14px}
.hp .fq-pay-plans{display:grid;gap:4px;margin:8px 0;padding:10px 12px;border-radius:10px;background:rgba(0,0,0,.035)}
.hp .fq-pay-plan{display:flex;align-items:flex-start;gap:8px;font-size:14px;line-height:1.7}
.hp .fq-pay-pi{flex:none;margin-top:.3em}
.hp .fq-pay-refund{display:block;margin-top:12px;padding-top:12px;border-top:1px solid rgba(0,0,0,.12);white-space:normal}
.hp .fq-who-no{margin-top:6px;padding-top:12px;border-top:1px solid rgba(0,0,0,.12);color:#6b6b6b}
.hp .fq-body{margin:.8em 0 0;font-size:15px;line-height:1.85;color:var(--ink);white-space:pre-line}
.hp .fq-more{display:inline-flex;align-items:center;min-height:44px;padding:0;background:none;border:0;font-size:14px;font-weight:700;color:var(--blue);text-decoration:underline;text-underline-offset:5px;cursor:pointer}
@media (min-width:768px){.hp .fq-more{display:none}}
@media (min-width:900px){.hp .fq{grid-template-columns:4fr 8fr}}

`;

export const FAQ_ENTRY_CSS = `/* FAQ の入口 (共有の部品なので源は触らず、HP の中だけで見た目を替える)。最初の画面の下は白、ページの中ほどは青みの白 */
.hp section[aria-label="FAQのご案内"]{padding:20px 0;background:#fff;border-bottom:1px solid var(--ink)}
.hp section[aria-label="FAQのご案内"]>div{max-width:1120px;padding:0 20px;gap:12px}
.hp section[aria-label="FAQのご案内"] p{margin:0;color:var(--ink)}
.hp section[aria-label="FAQのご案内"].bg-\\[\\#1a1a1a\\]{padding-top:var(--gap);padding-bottom:var(--gap);background:var(--blue-wash);border-bottom:0}
.hp section[aria-label="FAQのご案内"].bg-\\[\\#1a1a1a\\]>div{display:flex;flex-direction:column;align-items:flex-start;gap:20px;text-align:left}
.hp section[aria-label="FAQのご案内"].bg-\\[\\#1a1a1a\\] p:first-child{--font-body-ja:var(--mincho);font-size:clamp(20px,5.4vw,28px);font-weight:700;line-height:1.55;letter-spacing:.02em;text-wrap:balance}
.hp section[aria-label="FAQのご案内"] .text-white\\/65{margin-top:8px;font-size:14px;line-height:1.8;color:var(--sub)}
.hp #women-faq-trigger-hero,.hp #women-faq-trigger-mid-page{min-height:48px;padding:0 20px;border:1px solid var(--ink);border-radius:12px;background:#fff;color:var(--ink);font-size:14px;font-weight:700;margin-top:0}
.hp #women-faq-trigger-mid-page{background:var(--ink);color:#fff;border-radius:16px;min-height:52px;padding:0 24px}
.hp #women-faq-trigger-hero:hover{background:var(--blue-wash);transform:none}
.hp #women-faq-trigger-mid-page:hover{background:#000;transform:none}
@media (min-width:768px){
  .hp section[aria-label="FAQのご案内"]>div{padding:0 40px}
  .hp section[aria-label="FAQのご案内"].bg-\\[\\#1a1a1a\\]>div{flex-direction:row;align-items:center;justify-content:space-between;gap:40px}
}
`;
